import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SEO } from "@/lib/seo";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
    const { t } = useTranslation();
    return (
        <>
            <SEO title={t("notFound.seoTitle")} />
            <section className="container-page section-y">
                <div className="max-w-2xl mx-auto text-center">
                    <span className="chip-teal">{t("notFound.chip")}</span>
                    <h1 className="mt-3 font-display text-4xl sm:text-5xl font-semibold text-[color:var(--brand-navy)]">
                        {t("notFound.title")}
                    </h1>
                    <p className="mt-3 text-[color:var(--text-muted)]">
                        {t("notFound.body")}
                    </p>
                    <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
                        <Button asChild><Link to="/">{t("cta.returnHome")}</Link></Button>
                        <Button asChild variant="outline"><Link to="/services">{t("cta.exploreServices")}</Link></Button>
                    </div>
                </div>
            </section>
        </>
    );
}
